export const removeNullKeysFromObject = (obj) => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([, value]) => value != null)
      .map(([key, value]) => [
        key,
        value === Object(value) && !(value instanceof Date)
          ? removeNullKeysFromObject(value)
          : value,
      ])
  );
};
